module.exports = __webpack_public_path__ + "img/caso3.86a2f29a.jpeg";